import {useState} from 'react'
import {useGetUser} from '../../store/userStore'
import {isAdministrator} from '../../helpers'
import {TwilioBillingPage} from '../twilioBilling/TwilioBillingPage'
import {RebillingTab} from './RebillingTab'
import {UsageByNumberTab} from './UsageByNumberTab'
import {AssignmentsTab} from './AssignmentsTab'

// Billing hub (admin + supervisor). Admins see spend/usage/rebilling; supervisors
// see Assignments. Agents manage their own numbers under Profile → My Numbers.
export const BillingPage = () => {
  const permissions = useGetUser((s: any) => s.user?.permissions)
  const userGroups = useGetUser((s: any) => s.user?.groups) || []
  const isAdmin = isAdministrator(permissions || [])
  const isSupervisor = userGroups.includes('Supervisor')

  const tabs: {key: string; label: string}[] = []
  if (isAdmin) tabs.push({key: 'cost', label: 'Cost & Usage'})
  if (isAdmin) tabs.push({key: 'usage', label: 'Consumption by Number'})
  if (isAdmin) tabs.push({key: 'rebilling', label: 'Rebilling'})
  if (isAdmin || isSupervisor) tabs.push({key: 'assignments', label: 'Assignments'})

  const [active, setActive] = useState<string>('')
  const current = active || tabs[0]?.key || ''

  return (
    <div className='mt-5'>
      {tabs.length > 1 && (
        <ul className='nav nav-tabs nav-line-tabs fs-6 mb-2'>
          {tabs.map((t) => (
            <li className='nav-item' key={t.key}>
              <a
                className={`nav-link ${current === t.key ? 'active' : ''}`}
                style={{cursor: 'pointer'}}
                onClick={() => setActive(t.key)}
              >
                {t.label}
              </a>
            </li>
          ))}
        </ul>
      )}
      {current === 'cost' && <TwilioBillingPage />}
      {current === 'usage' && <UsageByNumberTab />}
      {current === 'rebilling' && <RebillingTab />}
      {current === 'assignments' && <AssignmentsTab />}
    </div>
  )
}
